<template>
  <div class="">

    <Head />


    <div class="main shiftSchedule">
      <AccesskeyLink target="accesskey_c" accesskey="c" aria-label="跳到中央內容區塊">
        :::
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item"><router-link to="/ScheduleList" :title="$t('排班列表')">{{ $t('排班列表') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('志工排班表') }}</li>
          </ol>
        </div>
      </nav>


      <div class="shiftSchedule_box">

        <div class="container">

          <div class="title_box">
            <h2>{{ scheduleName || $t('志工排班表') }}</h2>
          </div>

          <div class="schedule">

            <div class="volunteerName_box">
              <h3>{{ volunteerName }}</h3>
            </div>

            <!-- 圖示說明 -->
            <ul class="iconItems_box">
              <li v-for="(item, index) in iconItems" :key="index">
                <img :src="item.src" :alt="item.title">
                <p>{{ item.title }}</p>
              </li>
            </ul>

            <!-- 排班表 -->
            <div class="schedule_fixed">

              <!-- 右側日期表格 -->
              <div class="date_wrapper">
                <table class="schedule_table">
                  <thead>
                    <tr>
                      <th v-for="day in daysInPeriod" :key="day.dateStr" :class="day.isHoliday ? 'holiday' : 'weekday'">
                        <div class="day_box">
                          <div>{{ day.day }}</div>
                          <div class="week">（{{ day.weekday }}）</div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-for="day in daysInPeriod" :key="day.dateStr" class="date"
                        :class="day.isHoliday ? 'holiday' : 'weekday'">
                        <div class="date_box">
                          <button class="date_btn" 
                            :class="{ disabled: isDisabled(day.dateStr) }" 
                            :disabled="isDisabled(day.dateStr) || isSubmitted"
                            @click.stop="!isDisabled(day.dateStr) && !isSubmitted && openPicker(day.dateStr, $event)">
                            <img :src="getDayImg(day.dateStr)" />
                          </button>
                        </div>
                      </td>
                    </tr>
                    <!-- 打卡狀態列 -->
                    <tr class="checkin_status_row">
                      <td v-for="day in daysInPeriod" :key="'checkin-' + day.dateStr" class="checkin_status"
                        :class="day.isHoliday ? 'holiday' : 'weekday'">
                        <div class="checkin_box">
                          <!-- 上午打卡狀態 -->
                          <div class="shift_checkin" v-if="needCheckIn(day.dateStr, 'morning')">
                            <img v-if="hasCheckedIn(day.dateStr, 'morning')" 
                              src="/img/workdays_green.svg" 
                              :alt="getCheckInTimeAlt(day.dateStr, 'morning')"
                              :title="getCheckInTimeAlt(day.dateStr, 'morning')" />
                            <img v-else-if="isOverdueCheckIn(day.dateStr, 'morning')" 
                              src="/img/none_grey.svg" 
                              alt="逾時未打卡"
                              title="逾時未打卡" />
                          </div>
                          <!-- 下午打卡狀態 -->
                          <div class="shift_checkin" v-if="needCheckIn(day.dateStr, 'afternoon')">
                            <img v-if="hasCheckedIn(day.dateStr, 'afternoon')" 
                              src="/img/workdays_green.svg" 
                              :alt="getCheckInTimeAlt(day.dateStr, 'afternoon')"
                              :title="getCheckInTimeAlt(day.dateStr, 'afternoon')" />
                            <img v-else-if="isOverdueCheckIn(day.dateStr, 'afternoon')" 
                              src="/img/none_grey.svg" 
                              alt="逾時未打卡"
                              title="逾時未打卡" />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 班別選擇 Picker -->
              <div v-if="picker.visible && !isSubmitted" class="shift_picker" :style="{ top: picker.y + 'px', left: picker.x + 'px' }">
                <div v-for="opt in getFilteredShiftOptions()" :key="opt.id" class="option" @click="selectShift(opt.id)">
                  <img :src="opt.img" />
                  <div>{{ opt.text }}</div>
                </div>
              </div>

            </div>

            <div class="text_box">
              <p>
                {{ $t('注意事項') }}
                <br>
                {{ $t('星期四至星期二上午9時至12時及下午1時至4時，採兩班制。') }}
                <br>
                {{ $t('*如遇天然災害，依本市公佈放假標準為原則，不另行通知。') }}
              </p>
            </div>

            <div class="btn_box">
              <button v-if="!isSubmitted" class="send_btn" @click="saveSchedule">{{ $t('暫存') }}</button>
              <button v-if="!isSubmitted" class="send_btn" @click="submitSchedule">{{ $t('確認送出') }}</button>
            </div>

            <div class="btn_box">
              <button class="send_btn" @click="returnToList">{{ $t('返回列表') }}</button>
            </div>

          </div>

        </div>


      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';
import Swal from 'sweetalert2';

import AccesskeyLink from '@/views/AccesskeyLink.vue'



export default {

  name: 'VolunteerSchedule',
  components: {
    Head,
    Footer,

    AccesskeyLink,

  },

  data() {
    return {

      scheduleName: '',
      csId: 0,
      currentUserCsvId: 0,
      volunteerName: '',
      startDate: null,
      endDate: null,
      isSubmitted: false,
      availableSchedule: [], // 可服勤時段，格式：["Mon_1", "Tue_1", "Tue_2"]

      // 打卡記錄
      checkInStatus: [], // 格式：[{ scheduleDate, shiftType, hasCheckedIn, checkInTime }]

      iconItems: [
        {
          src: require('/public/img/AM.svg'),
          title: '上午場',
        },
        {
          src: require('/public/img/PM.svg'),
          title: '下午場',
        },
        {
          src: require('/public/img/ALL.svg'),
          title: '全日',
        },
      ],

      shiftOptions: [
        {
          id: 'morning',
          text: '上午場',
          img: require('/public/img/AM.svg'),
        },
        {
          id: 'afternoon',
          text: '下午場',
          img: require('/public/img/PM.svg'),
        },
        {
          id: 'fullday',
          text: '全日',
          img: require('/public/img/ALL.svg'),
        },
      ],

      // 排班記錄 格式: { 'date': 'shiftType' }
      schedules: {},

      // 不可編輯日
      lockedDates: [],

      picker: {
        visible: false,
        day: null,
        x: 0,
        y: 0
      },


    }
  },

  async mounted() {
    // 設定iconItems翻譯
    this.iconItems = [
      {
        src: require('/public/img/AM.svg'),
        title: this.$t('上午場'),
      },
      {
        src: require('/public/img/PM.svg'),
        title: this.$t('下午場'),
      },
      {
        src: require('/public/img/ALL.svg'),
        title: this.$t('全日'),
      },
    ]
    
    document.addEventListener('click', this.closePicker)

    // 檢查登入狀態
    const token = sessionStorage.getItem('scheduleToken')
    const csvId = sessionStorage.getItem('scheduleCSVId')
    const name = sessionStorage.getItem('scheduleName')
    
    if (!token || !csvId) {
      this.$router.push('/ScheduleLogin')
      return
    }

    this.currentUserCsvId = parseInt(csvId)
    this.volunteerName = name

    // 從路由參數取得 csId
    this.csId = parseInt(this.$route.params.csId)
    if (!this.csId) {
      await Swal.fire({
        icon: 'error',
        title: this.$t('錯誤'),
        text: this.$t('無效的排班 ID')
      })
      this.$router.push('/ScheduleList')
      return
    }

    // 載入排班資料
    await this.loadScheduleDetail()

    // 寬度等於表格寬度
    this.$nextTick(() => {
      const date = this.$el.querySelector('.date_wrapper')
      const container = this.$el.querySelector('.shiftSchedule_box .container')

      if (!date || !container) return

      const totalWidth = date.offsetWidth + 25

      container.style.maxWidth = totalWidth + 'px'
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closePicker)
  },

  computed: {
    daysInPeriod() {
      if (!this.startDate || !this.endDate) return []
      
      const days = []
      const start = new Date(this.startDate)
      const end = new Date(this.endDate)
      
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const dateStr = this.formatDate(d)
        const dayNum = d.getDate()
        const weekday = ['日', '一', '二', '三', '四', '五', '六'][d.getDay()]
        const isHoliday = d.getDay() === 0 || d.getDay() === 6
        
        days.push({ dateStr, day: dayNum, weekday, isHoliday })
      }
      
      return days
    }
  },

  methods: {

    async loadScheduleDetail() {
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/GetScheduleDetail`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            csvId: this.currentUserCsvId
          })
        })

        const result = await response.json()
        if (!result.ok) {
          await Swal.fire({
            icon: 'error',
            title: this.$t('載入失敗'),
            text: result.message || this.$t('載入失敗')
          })
          this.$router.push('/ScheduleList')
          return
        }

        // 設定基本資料
        this.scheduleName = result.scheduling.scheduleName
        this.startDate = result.scheduling.startDate
        this.endDate = result.scheduling.endDate
        this.isSubmitted = result.isSubmitted

        // 解析可服勤時段
        if (result.staffVolunteer.availableSchedule) {
          try {
            this.availableSchedule = JSON.parse(result.staffVolunteer.availableSchedule)
          } catch (e) {
            console.error('解析可服勤時段失敗:', e)
            this.availableSchedule = []
          }
        } else {
          this.availableSchedule = []
        }

        // 載入我的排班記錄（格式化日期）
        result.mySchedules.forEach(schedule => {
          const formattedDate = this.formatDate(schedule.scheduleDate)
          this.$set(this.schedules, formattedDate, schedule.shiftType)
        })

        // 載入打卡狀態
        await this.loadCheckInStatus()

      } catch (error) {
        console.error('載入排班資料失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: this.$t('載入失敗'),
          text: this.$t('載入排班資料失敗，請稍後再試')
        })
        this.$router.push('/ScheduleList')
      }
    },

    async saveSchedule() {
      try {
        // 收集我的排班記錄
        const mySchedules = []
        Object.keys(this.schedules).forEach(date => {
          mySchedules.push({
            scheduleDate: date,
            shiftType: this.schedules[date]
          })
        })

        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/SaveSchedule`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            csvId: this.currentUserCsvId,
            schedules: mySchedules
          })
        })

        const result = await response.json()
        if (result.ok) {
          await Swal.fire({
            icon: 'success',
            title: this.$t('暫存成功'),
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          await Swal.fire({
            icon: 'error',
            title: this.$t('暫存失敗'),
            text: result.message || this.$t('暫存失敗')
          })
        }

      } catch (error) {
        console.error('暫存失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: this.$t('暫存失敗'),
          text: this.$t('送出失敗，請稍後再試')
        })
      }
    },

    async submitSchedule() {
      const result = await Swal.fire({
        icon: 'question',
        title: this.$t('確認送出'),
        text: this.$t('確定要送出排班嗎？送出後將無法修改'),
        showCancelButton: true,
        confirmButtonText: this.$t('確定送出'),
        cancelButtonText: this.$t('取消'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      })
      
      if (!result.isConfirmed) {
        return
      }

      try {
        // 送出前先儲存排班資料
        const mySchedules = []
        Object.keys(this.schedules).forEach(date => {
          mySchedules.push({
            scheduleDate: date,
            shiftType: this.schedules[date]
          })
        })

        // 先呼叫 SaveSchedule API
        const saveApiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/SaveSchedule`;
        const saveResponse = await fetch(saveApiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            csvId: this.currentUserCsvId,
            schedules: mySchedules
          })
        })

        const saveResult = await saveResponse.json()
        if (!saveResult.ok) {
          await Swal.fire({
            icon: 'error',
            title: this.$t('儲存失敗'),
            text: saveResult.message || this.$t('儲存排班資料失敗')
          })
          return
        }

        // 儲存成功後，再呼叫 SubmitSchedule API
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/SubmitSchedule`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            csvId: this.currentUserCsvId
          })
        })

        const submitResult = await response.json()
        if (submitResult.ok) {
          await Swal.fire({
            icon: 'success',
            title: this.$t('送出成功'),
            text: this.$t('您的排班已成功送出'),
            showConfirmButton: false,
            timer: 2000
          })
          this.isSubmitted = true
        } else {
          await Swal.fire({
            icon: 'error',
            title: this.$t('送出失敗'),
            text: submitResult.message || this.$t('送出失敗')
          })
        }

      } catch (error) {
        console.error('送出失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: '送出失敗',
          text: '送出失敗，請稍後再試'
        })
      }
    },

    returnToList() {
      this.$router.push('/ScheduleList')
    },

    // 班別 picker
    openPicker(day, event) {
      if (this.isSubmitted) return
      
      // 檢查該日期可選擇的班別
      const availableShifts = this.getAvailableShifts(day)
      if (availableShifts.length === 0) {
        return // 沒有可選的班別，不開啟選擇器
      }
      
      this.picker = { visible: true, day, x: event.clientX, y: event.clientY }
    },
    
    // 取得過濾後的班別選項（只顯示可選的）
    getFilteredShiftOptions() {
      if (!this.picker.day) return []
      
      const availableShifts = this.getAvailableShifts(this.picker.day)
      return this.shiftOptions.filter(opt => availableShifts.includes(opt.id))
    },
    selectShift(shiftId) {
      const key = this.picker.day
      this.$set(this.schedules, key, shiftId)

      this.picker.visible = false
      this.picker.day = null
    },

    // 取得某日期可選擇的班別（根據可服勤時段）
    getAvailableShifts(dateStr) {
      const date = new Date(dateStr)
      const dayOfWeek = date.getDay() // 0=日, 1=一, 2=二, ..., 6=六
      
      // 將數字星期轉換為中文
      const dayMapping = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const dayName = dayMapping[dayOfWeek]
      
      // 檢查該星期幾的可服勤時段
      // 格式可能是 "星期一-09時-12時" 或 "Mon_1"（英文格式）
      const hasMorning = this.availableSchedule.some(slot => 
        slot === `${dayName}-09時-12時` || slot === `${dayName.replace('星期', '')}_1`
      )
      const hasAfternoon = this.availableSchedule.some(slot => 
        slot === `${dayName}-13時-16時` || slot === `${dayName.replace('星期', '')}_2`
      )
      
      const available = []
      
      // 根據可服勤時段決定可選的班別
      if (hasMorning && hasAfternoon) {
        // 上午和下午都可以 → 可選 AM, PM, ALL
        available.push('morning', 'afternoon', 'fullday')
      } else if (hasMorning) {
        // 只有上午可以 → 只能選 AM
        available.push('morning')
      } else if (hasAfternoon) {
        // 只有下午可以 → 只能選 PM
        available.push('afternoon')
      }
      
      return available
    },
    getShiftImg(day) {
      const shiftId = this.schedules[day]
      const opt = this.shiftOptions.find(o => o.id === shiftId)
      return opt ? opt.img : null
    },

    getDayImg(day) {
      // 有班別 → 優先顯示班別
      const shiftImg = this.getShiftImg(day)
      if (shiftImg) return shiftImg

      // 不能選 → 顯示鎖定圖
      if (this.isDisabled(day)) {
        return require('/public/img/none_grey.svg')
      }

      // 預設 → 顯示 +
      return require('/public/img/add_black.svg')
    },


    formatDate(date) {
      const d = typeof date === 'string' ? new Date(date) : date
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },

    // 格子 picker視窗開關
    closePicker() { this.picker.visible = false },


    // 判斷某一天是否不能選
    isDisabled(dateStr) {
      const date = new Date(dateStr)

      // 固定規則：每週三不能選 (getDay() === 3)
      if (date.getDay() === 3) return true

      // 不可編輯日
      if (this.lockedDates.includes(dateStr)) return true

      // 檢查該日期是否有任何可選的班別（根據可服勤時段）
      const availableShifts = this.getAvailableShifts(dateStr)
      if (availableShifts.length === 0) return true

      // 可選
      return false
    },

    // 載入打卡狀態
    async loadCheckInStatus() {
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/GetCheckInStatus`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csvId: this.currentUserCsvId,
            csId: this.csId
          })
        })

        const result = await response.json()
        if (result.ok) {
          this.checkInStatus = result.checkInStatus
        }
      } catch (error) {
        console.error('載入打卡狀態失敗:', error)
      }
    },

    // 判斷是否需要顯示打卡狀態（有排班記錄）
    needCheckIn(dateStr, shiftType) {
      const schedule = this.schedules[dateStr]
      if (!schedule) return false
      
      // morning = 上午, afternoon = 下午, fullday = 全日
      if (shiftType === 'morning') {
        return schedule === 'morning' || schedule === 'fullday'
      } else if (shiftType === 'afternoon') {
        return schedule === 'afternoon' || schedule === 'fullday'
      }
      return false
    },

    // 判斷是否已打卡
    hasCheckedIn(dateStr, shiftType) {
      const checkIn = this.checkInStatus.find(c => 
        this.formatDate(c.scheduleDate) === dateStr
      )
      if (!checkIn) return false
      
      // 根據 shiftType 檢查對應的時間欄位
      if (shiftType === 'morning') {
        return checkIn.morningCheckInTime != null && checkIn.morningCheckOutTime != null
      } else if (shiftType === 'afternoon') {
        return checkIn.afternoonCheckInTime != null && checkIn.afternoonCheckOutTime != null
      }
      return false
    },

    // 判斷是否逾時未打卡（今天之前的日期且未打卡）
    isOverdueCheckIn(dateStr, shiftType) {
      const date = new Date(dateStr)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      
      // 只有今天之前的日期才算逾時
      if (date >= today) return false
      
      // 有排班但未打卡
      return this.needCheckIn(dateStr, shiftType) && !this.hasCheckedIn(dateStr, shiftType)
    },

    // 取得打卡時間作為 alt 文字
    getCheckInTimeAlt(dateStr, shiftType) {
      const checkIn = this.checkInStatus.find(c => 
        this.formatDate(c.scheduleDate) === dateStr
      )
      if (!checkIn) return ''
      
      // 根據 shiftType 取得對應的時間
      let checkInTime = null
      let checkOutTime = null
      
      if (shiftType === 'morning') {
        checkInTime = checkIn.morningCheckInTime
        checkOutTime = checkIn.morningCheckOutTime
      } else if (shiftType === 'afternoon') {
        checkInTime = checkIn.afternoonCheckInTime
        checkOutTime = checkIn.afternoonCheckOutTime
      }
      
      if (checkInTime && checkOutTime) {
        const timeIn = new Date(checkInTime)
        const timeOut = new Date(checkOutTime)
        return `打卡: ${String(timeIn.getHours()).padStart(2, '0')}:${String(timeIn.getMinutes()).padStart(2, '0')} - ${String(timeOut.getHours()).padStart(2, '0')}:${String(timeOut.getMinutes()).padStart(2, '0')}`
      }
      return ''
    },

  }
}

</script>

<style scoped>
/* 打卡狀態列樣式 */
/* .checkin_status_row {
  background-color: #f8f9fa;
} */

.checkin_status {
  padding: 8px;
  text-align: center;
  /* border-left: 1px solid #dee2e6; */
}

/* .checkin_status.holiday {
  background-color: #ffe6e6;
} */

.checkin_box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0px;
  min-height: 40px;
  background-color: #efefef;
  margin: 0 3px;
}

.shift_checkin {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
}

.shift_checkin img {
  width: 24px;
  height: 24px;
  cursor: help;
}
</style>
